import { render, staticRenderFns } from "./KImageBanner.vue?vue&type=template&id=a75f6626&scoped=true&"
import script from "./KImageBanner.vue?vue&type=script&lang=ts&"
export * from "./KImageBanner.vue?vue&type=script&lang=ts&"
import style0 from "./KImageBanner.vue?vue&type=style&index=0&id=a75f6626&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75f6626",
  null
  
)

export default component.exports